var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"user-avatar-badge",class:['size-' + _vm.size],style:(_vm.badgeStyle),attrs:{"title":_vm.tooltip}},[(_vm.src)?_c('img',{staticClass:"avatar-img",attrs:{"src":_vm.src,"alt":""},on:{"error":_vm.onImgError}}):_c('span',{staticClass:"avatar-initials"},[_vm._v(_vm._s(_vm.initials))])])
}
var staticRenderFns = []

export { render, staticRenderFns }